import { z } from "zod/v4";

import { ExperienceDtoSchema } from "../../../dtos/experiences";

export const DuplicateExperienceRequestPathParamSchema = z.object({
  experienceId: z.uuid(),
});
export type DuplicateExperienceRequestPathParamType = z.infer<
  typeof DuplicateExperienceRequestPathParamSchema
>;

export const DuplicateExperienceResponseBodySchema = z.object({
  experience: ExperienceDtoSchema,
});
export type DuplicateExperienceResponseBodyType = z.infer<
  typeof DuplicateExperienceResponseBodySchema
>;
